import { useRef, useMemo } from 'react';

function useReferenceSafeObject(value) {
  const valueRef = useRef(value);
  return useMemo(() => {
    if (JSON.stringify(valueRef.current) === JSON.stringify(value)) {
      return valueRef.current;
    }
    valueRef.current = value;
    return value;
  }, [value]);
}

export { useReferenceSafeObject };
//# sourceMappingURL=useReferenceSafeObject.mjs.map
